import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const STerminalsFilterSelect = styled.div`
  gap: 16px;

  ${setFlexDFAIC};
`;
